import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ZoneState } from './zone.reducers';

// tslint:disable: max-line-length
export const zipsFeatureStateSelector = createFeatureSelector<ZoneState>('zone');

export const selectZones = createSelector(zipsFeatureStateSelector, (state: ZoneState) => state.zones);
export const selectZonesTotalCount = createSelector(zipsFeatureStateSelector, (state: ZoneState) => state.zonesTotalCount);
